import { ReactNode } from "react";
import Tooltip from "./Tooltip";
import { IndicatorIcon } from "@/assets/icons";

interface TooltipIndicatorProps {
  content: string;
  placement?: "top" | "bottom" | "left" | "right";
  size?: number;
  className?: string;
  children?: ReactNode;
  variant?: "success" | "error" | "info";
}

export default function TooltipIndicator({
  content,
  placement = "top",
  size = 20,
  className = "cursor-help",
  children,
  variant = "info",
}: TooltipIndicatorProps) {
  return (
    <Tooltip content={content} placement={placement} variant={variant}>
      {children || (
        <IndicatorIcon size={size} className={className} variant={variant} />
      )}
    </Tooltip>
  );
}
